import { Component, Input } from '@angular/core';
import { Comment } from '@model/comment/comment';
import { UserService } from '@service/user/user.service';
import { CommentService } from '@service/comment/comment.service';
import { LoadingService } from '@service/loading.service';

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss'],
})
export class CommentComponent {
  @Input() public comment: Comment = null;

  constructor(
    public userService: UserService,
    private commentService: CommentService,
    private loadingService: LoadingService,
  ) {}

  public delete() {
    this.loadingService.startLoad();
    this.commentService.deleteComment(this.comment.id);
  }
}
